import React from 'react';
import { Modal } from './Modal';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: PrivacyModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Política de Privacidad" data-id="element-90">
      <div className="space-y-4" data-id="element-91">
        <section data-id="element-92">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-93">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-94">Al realizar una compra, recopilamos la siguiente información:</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400" data-id="element-95">
            <li data-id="element-96">Nombre y apellido</li>
            <li data-id="element-97">Dirección de correo electrónico</li>
            <li data-id="element-98">
              Información de pago (procesada de forma segura por nuestro
              proveedor)
            </li>
          </ul>
        </section>

        <section data-id="element-99">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-100">
            2. Uso de la Información
          </h3>
          <p data-id="element-101">Utilizamos tu información personal únicamente para:</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400" data-id="element-102">
            <li data-id="element-103">Procesar tu compra y enviarte el producto digital</li>
            <li data-id="element-104">Enviarte confirmaciones y recibos de compra</li>
            <li data-id="element-105">Proporcionar soporte al cliente si lo necesitas</li>
            <li data-id="element-106">Cumplir con obligaciones legales</li>
          </ul>
        </section>

        <section data-id="element-107">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-108">
            3. Protección de Datos
          </h3>
          <p data-id="element-109">
            Implementamos medidas de seguridad para proteger tu información
            personal:
          </p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400" data-id="element-110">
            <li data-id="element-111">Encriptación SSL para todas las transacciones</li>
            <li data-id="element-112">Almacenamiento seguro de datos</li>
            <li data-id="element-113">Acceso restringido a información personal</li>
            <li data-id="element-114">No almacenamos información de tarjetas de crédito</li>
          </ul>
        </section>

        <section data-id="element-115">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-116">
            4. Compartir Información
          </h3>
          <p data-id="element-117">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros, excepto:
          </p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400" data-id="element-118">
            <li data-id="element-119">Procesadores de pago (para completar transacciones)</li>
            <li data-id="element-120">Cuando sea requerido por ley</li>
            <li data-id="element-121">Para proteger nuestros derechos legales</li>
          </ul>
        </section>

        <section data-id="element-122">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-123">
            5. Cookies y Tecnologías Similares
          </h3>
          <p data-id="element-124">
            Utilizamos cookies para mejorar tu experiencia en nuestro sitio web.
            Puedes configurar tu navegador para rechazar cookies, aunque esto
            puede afectar algunas funcionalidades.
          </p>
        </section>

        <section data-id="element-125">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-126">6. Tus Derechos</h3>
          <p data-id="element-127">Tienes derecho a:</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400" data-id="element-128">
            <li data-id="element-129">Acceder a tu información personal</li>
            <li data-id="element-130">Solicitar corrección de datos incorrectos</li>
            <li data-id="element-131">Solicitar eliminación de tus datos</li>
            <li data-id="element-132">Retirar tu consentimiento en cualquier momento</li>
          </ul>
        </section>

        <section data-id="element-133">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-134">
            7. Retención de Datos
          </h3>
          <p data-id="element-135">
            Conservamos tu información personal solo durante el tiempo necesario
            para cumplir con los propósitos descritos en esta política, o según
            lo requiera la ley.
          </p>
        </section>

        <section data-id="element-136">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-137">
            8. Cambios a esta Política
          </h3>
          <p data-id="element-138">
            Podemos actualizar esta política de privacidad ocasionalmente. Te
            notificaremos sobre cambios significativos publicando la nueva
            política en nuestro sitio web.
          </p>
        </section>

        <section data-id="element-139">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-140">9. Contacto</h3>
          <p data-id="element-141">
            Si tienes preguntas sobre esta política de privacidad o sobre cómo
            manejamos tus datos, contáctanos a través de nuestro correo
            electrónico de soporte.
          </p>
        </section>
      </div>
    </Modal>;
}